'use memo';
import { createFileRoute } from '@tanstack/react-router';

import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';

import { ProductTypeSelectionPage } from './-components/ProductTypeSelectionPage';

/**
 * プロダクト（Product）追加経路選択画面 (route 登録)。
 *
 * 本体は `-components/ProductTypeSelectionPage.tsx` に分離 (playbook §3.18:
 * AttributeCard + ActionButton + Grid + useNavigate + useTranslation の
 * generic を route 直下 inline すると cascade)。
 *
 * 不具合 (`/issues/add-select`) / 価値 (`/values/add-select`) と同じ並び・
 * カード構造を踏襲しつつ、Product は CSV / 外部同期が BE 未実装のため
 * どちらも disabled（開発中）にしている。
 */
export const Route = createFileRoute('/_stacktrace/products/add-select/')({
  component: ProductAddSelectRouteComponent,
});

function ProductAddSelectRouteComponent() {
  const { t } = useTranslation(stacktraceNS, {
    keyPrefix: 'products.addSelect',
  });
  useDocumentTitle(t('pageTitle'));
  return <ProductTypeSelectionPage />;
}
